import { useEffect, useState } from 'react'
import { useAuth } from '../../hooks/useAuth'
import { messages } from './KredittvurderingContainer.i18n'
import { useSelector, useDispatch } from 'react-redux'
import { ConfirmActionModal } from './modals/ConfirmActionModal'
import { clearData, clearRatingData, getCompanyRating, getPersonRating, getRatingInfo, getBislabCurrentTerms, updateDebtorRating, acceptCreditRating, disableRating } from '../../reduxStore/kredittvurdering/kredittvurderingActions'
import { useBislabTermsModal } from './modals/useBislabTermsModal'
import { useDeactivateModal } from './modals/useDeactivateModal'
import { useUcForm } from '../../hooks/useUcForm';

export const useKredittvurderingContainer = (locale) => {

    const showToasts = true;
    const localeMessages = messages[locale]

    // Activate global redux reducer
    const state = useSelector(state => state.kredittvurdering)
    const headerState = useSelector(state => state.sakslisteHeader)

    const dispatch = useDispatch()
    let selectedKreditor = headerState.kreditorId
    const auth = useAuth()
    const [isAccepted, setIsAccepted] = useState(false);

    // Hent data hver gang kreditor blir endret i dropdown
    useEffect(() => {
        if (!headerState.kreditorId) {
        } else {
            let currentKreditor = headerState.kreditorliste.find(e => e.customerNo === headerState.kreditorId)
            dispatch(clearData())
            
            if ((currentKreditor) && currentKreditor.kredittvurdering) {
                dispatch(getRatingInfo(headerState.kreditorId, showToasts, localeMessages, false))
            }
        }
    }, [headerState.kreditorId, isAccepted])

    const acceptTerms = async () => {

        const acceptFormData = new FormData()
        acceptFormData.append('creditorNo', selectedKreditor)
        acceptFormData.append('email', auth.user.email)
        acceptFormData.append('phone', auth.user.phonenumber)
        acceptFormData.append('termsId', '1')
        const result = await dispatch(acceptCreditRating(acceptFormData, selectedKreditor, showToasts, localeMessages));

        if (result) {
            let currentKreditor = headerState.kreditorliste.find(e => e.customerNo === headerState.kreditorId)
            currentKreditor.kredittvurdering = true
            var today = new Date();
            var dd = String(today.getDate()).padStart(2, '0');
            var mm = String(today.getMonth() + 1).padStart(2, '0');
            var yyyy = today.getFullYear();
            var formattedDate = dd + '.' + mm + '.' + yyyy;
            // Denne settes i backend, men gir den en verdi for å slippe og hente all brukerinfo på nytt da datoen ikke brukes til noe viktig.
            auth.user.bisLabDate = formattedDate;
            setIsAccepted(result);
        }
    }

    const deactivateCreditRating = async (deactivateKreditor) => {
    
        const deactivateFormData = new FormData();

        deactivateFormData.append('customerNo', selectedKreditor);
        deactivateFormData.append('emailUser', auth.user.email)
        deactivateFormData.append('deactivateKreditor', deactivateKreditor)

        try {
            const result = await dispatch(disableRating(deactivateFormData, selectedKreditor, showToasts, localeMessages));
            if (result === 'disabled') {
                auth.user.bisLabDate = null;
                // Laster siden på nytt om vellykket deaktivering.
                window.location.reload();
            } else {
                console.log('No valid data received');
            }
        } catch (error) {
            console.error(error);
        }
    };

    const getChosenRating = (type, value, debtorNo) => {
        dispatch(clearRatingData());
        type === 'Næring'
            ? dispatch(getCompanyRating(selectedKreditor, value, auth.user.email, debtorNo, showToasts, localeMessages))
            : dispatch(getPersonRating(selectedKreditor, value, auth.user.email, debtorNo, showToasts, localeMessages));
    };


    const getRatingInfoManually = () => {
        dispatch(getRatingInfo(headerState.kreditorId, showToasts, localeMessages, true))
    };

    let formValues = {   
        // Privat     
        fornavn: '',
        etternavn: '',
        bostedsadresseAdresse: '',
        bostedsadressePostnummer: '',
        bostedsadresseKommune: '',
        foedselsdato: '',

        nettoInntekt: '',
        nettoFormue: '',
        betalingsanmerkningerAntall: '',
        betalingsanmerkningerBelop: '',
        ligningsaar: '',

        skatt: '',
        kredittgrense: '',
        scoreForklaring: '',

        styrelederAntall: '',
        styremedlemAntall: '',
        dagligLederAntall: '',
        eierskapHelaarsbolig: '',
        eierskapMotorvogn: '',
        innehaverEnk: '',
        majoritetseierAs: '',
        score: '',
        scoreKarakter: '',        

        // Næring
        organisasjonsnummer: '',
        foretaksnavn: '',
        dagligLederNavn: '',
        forretningsadresseAdresse: '',
        forretningsadressePostnummer: '',
        forretningsadresseKommune: '',

        stiftelsesdato: '',
        antallAnsatte: '',
        betalingsanmerkningerAntall: '',
        betalingsanmerkningerBelop: '',
        regnskapsaar: '',

        scoreForklaring: '',
        kredittgrense: '',
        naeringskode: '',
        organisasjonsform: '',

        driftsinntekter: '',
        driftskostnader: '',
        driftsresultat: '',
        sumEgenkapital: '',
        sumEiendeler: '',
        sumGjeld: '',
        score: '',
        scoreKarakter: '',
    }
    let formValidators = null

    const {
        handleChange, handleCheckboxChange, setField, handleMultiSelectChange,
        formState, validateField, validateAll, errorMessages,
        formIsValid, validatorsState
    } = useUcForm(formValues, formValidators)

    const fetchBislabTerms = () => dispatch(getBislabCurrentTerms(showToasts, localeMessages))

    const termsModal = useBislabTermsModal(localeMessages, acceptTerms, fetchBislabTerms, state.termsBase64)
    const deactivateModal = useDeactivateModal(localeMessages, deactivateCreditRating, auth.user.email, selectedKreditor)

    return {
        localeMessages, selectedKreditor, state, headerState, clearData, clearRatingData, getCompanyRating, getPersonRating, getRatingInfo, updateDebtorRating, getBislabCurrentTerms, 
        acceptCreditRating, disableRating, getChosenRating, termsModal, deactivateModal, formValues, formValidators, formValues, formValidators, handleChange, formState, setField,
        errorMessages, isAccepted, getRatingInfoManually
    }
}